import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './about.css'

const About = (props) => {
  return (
    <a
      href={props.aboutComponent}
      target="_blank"
      rel="noreferrer noopener"
      className="about-link"
    >
      <div
        id={props.aboutId}
        className={`about-container ${props.rootClassName} `}
      >
        <div className="about-top-container">
          <div className="about-left-container">
            <span id={props.aboutMeTitleId} className="about-aboutmetitle">
              {props.aboutMeTitle ?? (
                <Fragment>
                  <span className="about-text13">About me</span>
                </Fragment>
              )}
            </span>
            <span className="about-text10">
              {props.aboutMeText ?? (
                <Fragment>
                  <span className="about-text18">
                    <span>Hi there!</span>
                    <br></br>
                    <br></br>
                    <span>
                      I&apos;m Stefan Lacher, a passionate Data Engineer, System
                      Architect and Sociologist with a knack for transforming
                      raw data into valuable insights. With a diverse skill set
                      spanning multiple technologies, I excel at navigating
                      complex data landscapes to deliver comprehensive,
                      end-to-end solutions. I thoroughly enjoy tackling problems
                      from planning and experimentation to professionalization
                      and bringing solutions to production level.
                    </span>
                    <br></br>
                    <br></br>
                    <span>
                      With a Master’s in Sociology from the University of Graz,
                      I have a strong foundation in both the theoretical and
                      practical aspects of data science and engineering. My
                      academic journey and professional experiences have
                      equipped me with the ability to address real-world
                      problems through meticulous research and advanced data
                      methodologies.
                    </span>
                    <br></br>
                    <br></br>
                  </span>
                </Fragment>
              )}
            </span>
          </div>
          <div className="about-right-container">
            <div className="about-top-right-container">
              <div className="about-top-right-rowcontainer">
                <span className="about-achievementstitle">
                  {props.achievementsTitle ?? (
                    <Fragment>
                      <span className="about-text29">
                        <span>
                          <span
                            dangerouslySetInnerHTML={{
                              __html: ' ',
                            }}
                          />
                        </span>
                        <span className="about-text31">
                          Professional Key Achievements
                        </span>
                      </span>
                    </Fragment>
                  )}
                </span>
                <span className="about-text11">
                  {props.achievementsText ?? (
                    <Fragment>
                      <span className="about-text32">
                        <span>
                          Successfully led data engineering projects at Epitome,
                          focusing on robust, scalable, real-time data pipelines
                          and software.
                        </span>
                        <br></br>
                        <br></br>
                        <span>
                          Implemented a data strategy for Epitome and data
                          privacy policies ensuring compliance with GDPR.
                        </span>
                        <br></br>
                        <br></br>
                        <span>
                          Utilized computer vision for object detection and
                          analysis in image data.
                        </span>
                        <br></br>
                        <br></br>
                      </span>
                    </Fragment>
                  )}
                </span>
              </div>
            </div>
            <div className="about-bottomrightcontainer">
              <div className="about-bottomrightrowcontainer">
                <span className="about-currenttitle">
                  {props.endeavorsTitle ?? (
                    <Fragment>
                      <span className="about-text28">
                        Current and Future Endeavors
                      </span>
                    </Fragment>
                  )}
                </span>
                <span className="about-text12">
                  {props.endeavorsText ?? (
                    <Fragment>
                      <span className="about-text14">
                        <span>
                          My current role is as a System Architect with a focus
                          on software development for the IT Service Management
                          and IT Infrastructure department at the Bundesamt für
                          Eich- und Vermessungswesen (BEV). This position
                          involves developing and maintaining software
                          architectures and solutions, rolling out new software
                          versions, and integrating them into existing systems.
                        </span>
                        <br></br>
                        <br></br>
                      </span>
                    </Fragment>
                  )}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </a>
  )
}

About.defaultProps = {
  aboutMeTitle: undefined,
  endeavorsText: undefined,
  aboutId: '',
  rootClassName: '',
  aboutMeText: undefined,
  endeavorsTitle: undefined,
  achievementsTitle: undefined,
  achievementsText: undefined,
  aboutMeTitleId: 'AboutMeTag',
  aboutComponent: 'https://www.teleporthq.io',
}

About.propTypes = {
  aboutMeTitle: PropTypes.element,
  endeavorsText: PropTypes.element,
  aboutId: PropTypes.string,
  rootClassName: PropTypes.string,
  aboutMeText: PropTypes.element,
  endeavorsTitle: PropTypes.element,
  achievementsTitle: PropTypes.element,
  achievementsText: PropTypes.element,
  aboutMeTitleId: PropTypes.string,
  aboutComponent: PropTypes.string,
}

export default About
